module.exports = __webpack_public_path__ + "img/logo-old.67f1e296.png";